<template>
  <div class="h100">
    <div v-if="!listData.length" class="objection-empty">暂无异议</div>
    <div v-else class="flex-column h100">
      <div class="flex-1 objection-list">
        <el-scrollbar class="scrollbar-y-hidden" style="height: 100%;">
          <div
            v-for="(item, index) in listData"
            :id="current.objectionId == item.objectionId ? 'scrollItemId': ''"
            :key="index"
            class="project-item"
            :class="{'active': current.objectionId == item.objectionId}"
            @click="clickItem(item)"
          >
            <div class="project-item__attr">
              <div class="code">{{ item.objectionCode }}</div>
            </div>
            <div class="project-item__title text-bold">{{ item.objectionName }}</div>
            <div v-if="item.objectionStatus == objectionStatusDict.NOREPLY.value" class="project-item__objection">
              异议：{{ item.content }}
            </div>
            <div v-if="item.objectionStatus == objectionStatusDict.YESREPLY.value" class="project-item__objection">
              异议答复：{{ item.content }}
            </div>
            <div class="flex flex-align__between project-item__last">
              <span class="status" :class="['status', getStatus(item).type || '']">{{ getStatus(item).label }}</span>
              <span v-if="item.objectionStatus == objectionStatusDict.NOREPLY.value" class="time">供应商提交时间：{{ item.submitTime || '-' }}</span>
              <span v-if="item.objectionStatus == objectionStatusDict.YESREPLY.value" class="time">采购方答复时间：{{ item.submitTime || '-' }}</span>
            </div>
          </div>
        </el-scrollbar>
      </div>

      <div v-if="total > 0" class="objection-listpage">
        <pagination
          :total="total"
          :page.sync="curPage"
          :limit.sync="curSize"
          :auto-scroll="false"
          layout="total, sizes, prev, pager, next"
          @pagination="pagination"
        />
      </div>
    </div>
  </div>
</template>
<script>
// 组件
import Pagination from '@/components/common/Pagination'

// 数据字典
import { objectionStatusDict } from '@/dictionary/project/common'

export default {
  components: {
    Pagination
  },

  props: {
    listData: {
      type: Array,
      default: () => {
        return []
      }
    },

    total: {
      type: Number,
      default: 0
    },

    page: {
      type: Number,
      default: 1
    },

    size: {
      type: Number,
      default: 10
    },

    /**
     * 当前选中
     */
    current: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      objectionStatusDict
    }
  },

  computed: {
    curPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },

    curSize: {
      get() {
        return this.size
      },
      set(val) {
        this.$emit('update:size', val)
      }
    }
  },

  methods: {
    setScroll() {
      this.$nextTick(() => {
        document.getElementById('scrollItemId') && document.getElementById('scrollItemId').scrollIntoView({
          behavior: 'smooth'
        })
      })
    },

    getStatus(item) {
      return objectionStatusDict.translate(item.objectionStatus) || {}
    },
    pagination(data) {
      this.$emit('pagination', data)
    },

    clickItem(item) {
      this.$emit('clickItem', item)
    }
  }
}
</script>
<style lang="scss" scoped>
// 三点省略 支持单行多行
// Mixin { n:Number } n：省略行数限制
@mixin ellipsis($n) {
  overflow: hidden;
  text-overflow: ellipsis;

  @if $n > 1 {
    display: -webkit-box;
    -webkit-line-clamp: $n;
    -webkit-box-orient: vertical;
  } @else {
    white-space: nowrap;
  }
}

.h100 {
  height: 100%;
}

.objection-empty {
  padding: 100px 0 0;
  text-align: center;
  font-size: 16px;
  color: $third-text-color;
}

.objection-list {
  overflow: hidden;
}

.objection-listpage {
  text-align: right;
}

.project-item {
  padding: 16px 24px;
  cursor: pointer;

  &:hover,
  &.active {
    background: $primary-fourth-color;
  }

  &__attr {
    .code {
      display: inline-block;
      padding:0 5px;
      border:1px solid $info-second-color;
      border-radius: 2px;
      font-size: 12px;
      line-height: 20px;
      color: $third-text-color;
    }
  }

  &__title {
    margin-top: 8px;
    font-size: 14px;
    line-height: 22px;
    color: $text-color;
    @include ellipsis(2);
  }

  &__objection {
    margin-top: 8px;
    font-size: 12px;
    line-height: 18px;
    color: $second-text-color;
    @include ellipsis(1);
  }

  &__last {
    margin-top: 20px;
    .status {
      padding: 0 6px;
      color: $white-color;
      font-size: 12px;
      line-height: 20px;
      background: $primary-color;

      &.danger {
        background: $danger-color;
      }

      &.success {
        background: $success-color;
      }

      &.warning {
        background: $warning-color;
      }
    }
    .time {
      font-size: 12px;
      line-height: 18px;
      color: $third-text-color;
    }
  }
}
</style>